import fetcher, { makeFetcher } from '@sls-react/api/fetcher';
import {
  RailsCategory,
  RailsDetailGuidance,
} from '@sls-react/typings/services/rails/item';

export type DetailGuidanceContext = 'list' | 'shop';

export const fetchDetailGuidance = makeFetcher<
  RailsDetailGuidance[],
  [categoryId: number | string, context: DetailGuidanceContext]
>(
  (categoryId: number | string, context: DetailGuidanceContext) =>
    `/v1/categories/${categoryId}/details/meta?context=${context}`,
);

export const fetchCategories = makeFetcher<RailsCategory[], []>(
  () => '/v1/categories',
);

export const fetchCategoryById = makeFetcher<
  RailsCategory,
  [categoryId: number | string]
>((categoryId: number | string) => `/v1/categories/${categoryId}`);
